export default class FakturaEditCtrl {

  constructor(FakturaciaService, $scope, faktura){
      this.FakturaciaService = FakturaciaService;
      this.invoice = faktura || {
        "cisloFaktury": "1701012394",
        "typDokladu": "Daňový doklad",
        "partA": {
          "mena": "CZK",
          "dodavatel": {
            "nazov": "Axpo Solutions AG",
            "ulicaCislo": "Parkstrasse 23",
            "psc": "CH-5401",
            "mesto": "Baden",
            "stat": "Schweiz",
            "ic": "CHE-105.779.348",
            "icDPH": "CHE-105.779.348 MWST",
            "obchodniRejstrik": "Commercial Register of canton Zürich"
          },
          "odberatel": {
            "nazov": "Axpo Solutions AG",
            "ulicaCislo": "Parkstrasse 23",
            "psc": "CH-5401",
            "mesto": "Baden",
            "stat": "Schweiz",
            "ic": "CHE-105.779.348",
            "icDPH": "CHE-105.779.348 MWST",
            "bankovniUcet": "SK31 1200 0000 1987 4263 7541"
          },
          "detailPlatby": {
            "variabilnySymbol": "91125945-7",
            "datumSplatnosti": "2017-11-30T00:00:00.000Z",
            "datumVystaveni": "2017-10-18T00:00:00.000Z",
            "datumZdanitelnehoPlneni": "2017-10-01T00:00:00.000Z",
            "obdobiOd": "2017-09-01T00:00:00.000Z",
            "obdobiDo": "2017-09-30T00:00:00.000Z",
            "formaUhrady": "bankovní převod",
            "placeniDPH": "Daň odvede zákazník"
          },
          "bankoveUcty": [
            {
              "mena": "CZK",
              "nazovBanky": "Deutsche Bank Prague",
              "iban": "CZ10 7910 0000 0040 2160 0011",
              "swift": "DEUTCZPX"
            },
            {
              "mena": "EUR",
              "nazovBanky": "Deutsche Bank AG, D-60311 Frankfurt",
              "iban": "DE55 5007 0010 0175 4233 01",
              "swift": "DEUTDEFFXXX"
            }
          ],
          "detailPlatby": {
            "variabilnySymbol": "91125945-7",
            "datumSplatnosti": "2017-11-30T00:00:00.000Z",
            "datumVystaveni": "2017-10-18T00:00:00.000Z",
            "datumZdanitelnehoPlneni": "2017-10-01T00:00:00.000Z",
            "obdobiOd": "2017-09-01T00:00:00.000Z",
            "obdobiDo": "2017-09-30T00:00:00.000Z",
            "formaUhrady": "Bankovní převod",
            "placeniDPH": "Daň odvede zákazník"
          },
          "rekapitulace": [
            {
              "zaokrouhleni": 0,
              "celkem": 340681.45,
              "mena": "CZK",
              "items": [
                {
                  "polozka": "Spotřeba plynu a souvisejících služeb",
                  "sazbaDPH": 0,
                  "zakladDPH": 340681.45,
                  "DPH": 0,
                  "celkem": 340681.45
                },
                {
                  "polozka": "Přijaté platby",
                  "sazbaDPH": 0,
                  "zakladDPH": 0,
                  "DPH": 0,
                  "celkem": 0
                },
                {
                  "polozka": "Rozdíl ke zdanění",
                  "sazbaDPH": 0,
                  "zakladDPH": 340681.45,
                  "DPH": 0,
                  "celkem": 340681.45
                }
              ]
            },
            {
              "zaokrouhleni": 0,
              "celkem": 340681.45,
              "mena": "EUR",
              "items": [
                {
                  "polozka": "Spotřeba plynu a souvisejících služeb",
                  "sazbaDPH": 0,
                  "zakladDPH": 340681.45,
                  "DPH": 0,
                  "celkem": 340681.45
                },
                {
                  "polozka": "Přijaté platby",
                  "sazbaDPH": 0,
                  "zakladDPH": 0,
                  "DPH": 0,
                  "celkem": 0
                },
                {
                  "polozka": "Rozdíl ke zdanění",
                  "sazbaDPH": 0,
                  "zakladDPH": 340681.45,
                  "DPH": 0,
                  "celkem": 340681.45
                }
              ]
            }
          ],
          "prijatePlatby": {
            "spolu": 14000,
            "items": [
              {
                "datum": "2017-10-10T00:00:00.000Z",
                "suma": 4500
              },
              {
                "datum": "2017-10-10T00:00:00.000Z",
                "suma": 4600
              },
              {
                "datum": "2017-10-10T00:00:00.000Z",
                "suma": 4700
              },
              {
                "datum": "2017-10-10T00:00:00.000Z",
                "suma": 4800
              }
            ]
          }
        },
        "partsB": [
          {
            "odberneMiesto": {
              "obdobiOd": "2017-10-01T00:00:00.000Z",
              "obdobiDo": "2017-10-31T00:00:00.000Z",
              "zakaznik": "NAVOS, a.s.",
              "nazev": "NAVOS, a.s._Moravský Krumlov",
              "adresa": "Pod Leskounem 1282, 67175 Moravský Krumlov",
              "eic": "27ZG600Z0000101U",
              "distributor": "GasNet, s.r.o.",
              "pripojeni": "Dálkovod",
              "mereni": "A"
            },
            "detailSpotreby": {
              "celkemRozdil": 44938,
              "celkemSpotreba": 479.372,
              "items": [
                {
                  "cisloPlynomeru": "20402159",
                  "obdobiOd": "2017-10-01T00:00:00.000Z",
                  "obdobiDo": "2017-10-31T00:00:00.000Z",
                  "pocetMesicu": 1,
                  "pocatecniStav": 107116,
                  "koncovyStav": 152054,
                  "rozdil": 44938,
                  "spotrebakWh": 479372.32,
                  "spotrebaMWh": 479.37232
                }
              ]
            },
            "dodavkaPlynu": {
              "mena": "CZK",
              "spolu": 209964.94,
              "items": [
                {
                  "polozka": "Odebraný plyn",
                  "mernaJednotka": "MWh",
                  "pocetJednotek": 479.372,
                  "jednotkovaCena": 438.00,
                  "podilObdobi": null,
                  "zakladDane": 209964.94
                }
              ]
            },
            "danZPlynu": {
              "mena": "CZK",
              "spolu": 14668.78,
              "poznamka": "Zemní plyn byl dodán za účelem použití ve smyslu § 4 písm. a) zákona č. 261/2007 Sb., část 45",
              "items": [
                {
                  "polozka": "Zemní plyn osvobozený od daně ze zemního plynu",
                  "mernaJednotka": "MWh",
                  "pocetJednotek": 0,
                  "jednotkovaCena": 0,
                  "podilObdobi": null,
                  "zakladDane": 0
                },
                {
                  "polozka": "Základ daně ze zemního plynu",
                  "mernaJednotka": "MWh",
                  "pocetJednotek": 479.372,
                  "jednotkovaCena": 30.6,
                  "podilObdobi": null,
                  "zakladDane": 14668.78
                }
              ]
            },
            "distribucePlynu": {
              "mena": "CZK",
              "spolu": 116047.73,
              "items": [
                {
                  "polozka": "Cena za denní rezervovanou pevnou distribuční kapacitu",
                  "mernaJednotka": "tis. m3/den/rok",
                  "pocetJednotek": 0.150,
                  "jednotkovaCena": 202102.37,
                  "podilObdobi": "1/12",
                  "zakladDane": 2526.28
                },
                {
                  "polozka": "Cena za denní rezervovanou pevnou klouzavou distribuční kapacitu",
                  "mernaJednotka": "tis. m3/den/...",
                  "pocetJednotek": 0.65,
                  "jednotkovaCena": 19389.02,
                  "podilObdobi": 0.484,
                  "zakladDane": 6098.16
                },
                {
                  "polozka": "Cena za denní rezervovanou pevnou klouzavou distribuční kapacitu",
                  "mernaJednotka": "tis. m3/den/...",
                  "pocetJednotek": 3.35,
                  "jednotkovaCena": 16572.26,
                  "podilObdobi": 0.677,
                  "zakladDane": 37608.34
                },
                {
                  "polozka": "Platba za překročení denní rezervované pevné distribuční kapacity",
                  "mernaJednotka": "tis. m3/den/měs.",
                  "pocetJednotek": 1.56,
                  "jednotkovaCena": 38942.33,
                  "podilObdobi": 1,
                  "zakladDane": 60750.03
                },
                {
                  "polozka": "Cena za odebraný plyn",
                  "mernaJednotka": "MWh",
                  "pocetJednotek": 479.372,
                  "jednotkovaCena": 16.51,
                  "podilObdobi": null,
                  "zakladDane": 7914.43
                },
                {
                  "polozka": "Cena OTE za činnost zúčtování",
                  "mernaJednotka": "MWh",
                  "pocetJednotek": 479.372,
                  "jednotkovaCena": 2.4,
                  "podilObdobi": null,
                  "zakladDane": 1150.49
                }
              ]
            },
            "celkemZaObdobi": {
              "spotreba": 168.599,
              "zakladDane": 11359.46,
              "mena": "EUR",
              "kurz": 25.995,
              "povodnaMena": "CZK",
              "zdrojKurzu": "ČNB",
              "datumKurzu": "2017-10-02T00:00:00.000Z",
              "items": [
                {
                  "nazov": "Dodávka elektřiny",
                  "povodnaCena": null,
                  "cena": 4658.39
                },
                {
                  "nazov": "Daň z elektřiny",
                  "povodnaCena": 4771.35,
                  "cena": 183.55
                },
                {
                  "nazov": "Distribuce a související služby",
                  "povodnaCena": 169422.91,
                  "cena": 183.55
                }
              ]
            }
          }
        ],
        "partsC": [
          {
            "meridloCislo": "20402159",
            "celkemPrepocSpotreba": 44938,
            "celkemSpotreba": 479372.32,
            "items": [
              {
                "den": "2017-10-01T00:00:00.000Z",
                "stavMeridla": 107116,
                "prepoctenaSpotreba": 661,
                "spalneTeplo": 10.6945,
                "spotreba": 7069.07
              }
            ]
          }
        ]
      };
      this.CURRENCIES = ["CZK", "EUR"];

      this.CURRENCY_STRINGS = {
        CZK: "Kč",
        EUR: "€"
      }

      $scope.$watch(angular.bind(this, () => this.invoice.partA.mena), (value) => {
        if (value == "CZK")
          this.currencyString = "Kč";
        else
          this.currencyString = "€";
      });

      this.currencyStrings = {
        CZK: "Kč",
        EUR: "€"
      };

      this.tabs = [
        {
          title: "Časť A",
          templateURL: "'src/Fakturacia/castA.html'"
        }
      ];

      this.prepocetMeny = [];

      for (let dataB of this.invoice.partsB) {
        if ('celkemZaObdobi' in dataB)
          this.prepocetMeny.push('povodnaMena' in dataB.celkemZaObdobi)
        else
          this.prepocetMeny.push(false);
      }
  }

  addAccount() {
    if (!this.invoice.partA.bankoveUcty)
      this.invoice.partA.bankoveUcty = [];

    this.invoice.partA.bankoveUcty.push({});
  }

  removeAccount(index) {
    this.invoice.partA.bankoveUcty.splice(index, 1);
  }


  addPayment() {
    this.invoice.partA.prijatePlatby.items.push({});
  }

  removePayment(index) {
    this.invoice.partA.prijatePlatby.items.splice(index, 1);
  }

  addRekapitulace() {
    if (!this.invoice.partA.rekapitulace)
      this.invoice.partA.rekapitulace = [];

    this.invoice.partA.rekapitulace.push({items: []});
  }

  removeRekapitulace(index) {
    this.invoice.partA.rekapitulace.splice(index, 1);
  }

  addPolozkaRekapitulace(index) {
    this.invoice.partA.rekapitulace[index].items.push({});
  }

  removePolozkaRekapitulace(index) {
    this.invoice.partA.rekapitulace.items.splice(index, 1);
  }


  removeDetailSpotrebyItem(partBIndex, itemIndex) {
    this.invoice.partsB[partBIndex].detailSpotreby.items.splice(itemIndex, 1);
  }

  addDetailSpotrebyItem(index) {
    this.invoice.partsB[index].detailSpotreby.items.push({});
  }


  removeStrukturaPlatebItem(partBIndex, itemIndex, itemName) {
    this.invoice.partsB[partBIndex][itemName].items.splice(itemIndex, 1);
  }

  addStrukturaPlatebItem(index, itemName) {
    this.invoice.partsB[index][itemName].items.push({});
  }


  addCelkomTableItem(index) {
    this.invoice.partsB[index].celkemZaObdobi.items.push({});
  }

  removeCelkemTableItem(partBIndex, itemIndex) {
    this.invoice.partsB[partBIndex].celkemZaObdobi.items.splice(itemIndex, 1);
  }


  removePartCItem(partCIndex, itemIndex) {
    this.invoice.partsC[partCIndex].items.splice(itemIndex, 1);
  }

  addPartCItem(index) {
    if (!this.invoice.partsC[index].items)
      this.invoice.partsC[index].items = [];

    this.invoice.partsC[index].items.push({});
  }


  addPart(partName) {
    if (partName == 'partA')
      this.invoice[partName] = {};
    else
      this.invoice[partName].push({});
  }


  removePart(part, index) {
    if (part == "partA")
      delete this.invoice.partA;
    else
      this.invoice[part].splice(index, 1);
  }


  addTable(part, index, item, createItems = false) {
    let newItem = {};

    if (createItems) newItem.items = [];

    if (part == "partA")
      this.invoice.partA[item] = newItem;
    else
      this.invoice[part][index][item] = newItem;
  }

  onPrepocetClicked(index) {
    let table = this.invoice.partsB[index].celkemZaObdobi;
    table.povodnaMena = table.mena;
  }

  saveInvoice() {
    this.FakturaciaService.exportXls(this.invoice);
  }

}


// WEBPACK FOOTER //
// ./src/Fakturacia/FakturaEditCtrl.js